import Copy from './Copy';
import Cta, { ctaProps } from './Cta';
import { GlowSm } from './Decor';

/* Frosted-glass offer card used for the two hero offers. `data` is the API
   section ({ text, highlight, cta }); `art` is an optional image that pokes
   out above the card. */
export default function OfferCard({ className = '', art, alt = '', data, onAction }) {
  const cta = ctaProps(data.cta, onAction);
  return (
    <section className={'bbd-glass bbd-offer ' + className}>
      <GlowSm />
      {art && <img className="bbd-offer-art" src={art} alt={alt} />}
      <p className="bbd-copy"><Copy text={data.text} highlight={data.highlight} /></p>
      {/* a disabled CTA (e.g. a completed "Credited" milestone) reads as a status,
          so drop the forward arrow */}
      <Cta {...cta} hideArrow={cta.disabled} />
    </section>
  );
}
